import {UI} from "../../../../../../stem-core/ui/UIBase";
import {NOOP_FUNCTION} from "../../../../../../stem-core/base/Utils";
import {PaymentMethod} from "../../../../../../client/state/PaymentMethodStore";
import {autoredraw} from "../../../../../../stem-core/decorators/AutoRedraw";
import {PaymentMethodSelectInput} from "./PaymentMethodSelectInput.jsx";


// TODO @cleanup this is crap
@autoredraw(PaymentMethod)
export class ChooseCardComponent extends UI.Element {
    getDefaultOptions() {
        return {
            initialValue: null,
            onAddCard: NOOP_FUNCTION,
            onChange: NOOP_FUNCTION,
            testId: "chooseCard",
            entry: null,
        };
    }

    constructor(...args) {
        super(...args);

        this.value = this.options.initialValue;
    }

    isValid() {
        return true;
    }

    getActive() {
        return this.value;
    }

    async getPaymentMethod() {
        return this.value;
    }

    handleCardSelection(card) {
        this.value = card;
        this.redraw();
        this.options.onChange(card);
    }

    render() {
        const {onAddCard, entry} = this.options; // TODO @cleanup entry should be rename to something else/removed

        return [
            <PaymentMethodSelectInput
                initialValue={this.value}
                onChange={(card) => this.handleCardSelection(card)}
                onAddCard={onAddCard}
                showHeader={true}
                recurringPayment={entry}
                showDescription={true}
            />,
        ]
    }
}
